export const CAPABILITY_SET_NAMES = {
    MANAGER: 'Manager',
    CUSTOM: 'Custom'
};

export const CAPABILITIES = Object.freeze({
    // admin menu items
    MANAGE_CLIENTS: 'manage_clients',
    MANAGE_VENDORS: 'manage_vendors',
    MANAGE_ACTIVITIES: 'manage_activities',
    MANAGE_ACTIVITY_TAGS: 'manage_activity_tags',
    MANAGE_TERMINAL_LOCATIONS: 'manage_terminal_locations',
    MANAGE_CHAINS: 'manage_chains',
    MANAGE_EMAILS: 'manage_emails',
    MANAGE_SYSTEM_FEES: 'manage_system_fees',
    MANAGE_BOOKING_PAYOUTS: 'manage_booking_payouts',
    MANAGE_PAYOUT_REPORTS: 'manage_payout_reports',
    MANAGE_CUSTOM_REPORTS: 'manage_custom_reports',
    MANAGE_SALES_REPORTS: 'manage_sales_reports',
    MANAGE_REGIONS: 'manage_regions',
    MANAGE_CANCEL_REASONS: 'manage_cancel_reasons',
    MANAGE_SOURCES: 'manage_sources',
    MANAGE_SOURCE_GROUPS: 'manage_source_groups',
    MANAGE_AUDIT_LOGS: 'manage_audit_logs',
    MANAGE_HOTELS: 'manage_hotels',
    MANAGE_PRICE_ITEM_NAMES: 'manage_price_item_names',
    MANAGE_BATCHES: 'manage_batches',
    // features
    RE_SOURCE_BOOKING: 're_source_booking',
    SEND_CUSTOM_MESSAGES: 'send_custom_messages',
    ALLOW_REFUND_OUTSIDE_CANCEL_WINDOW: 'allow_refund_outside_cancel_window',
    ALLOW_REFUND_WITHIN_CANCEL_WINDOW: 'allow_refund_within_cancel_window',
    ALLOW_MODIFY_OUTSIDE_CANCEL_WINDOW: 'allow_modify_outside_cancel_window',
    ALLOW_MODIFY_WITHIN_CANCEL_WINDOW: 'allow_modify_within_cancel_window',
    SHOW_DASHBOARD_ALERTS: 'show_dashboard_alerts'
});

export const CAPABILITY_SETS = Object.freeze({
    [CAPABILITY_SET_NAMES.MANAGER]: [
        CAPABILITIES.MANAGE_CLIENTS,
        CAPABILITIES.MANAGE_VENDORS,
        CAPABILITIES.MANAGE_ACTIVITIES,
        CAPABILITIES.MANAGE_ACTIVITY_TAGS,
        CAPABILITIES.MANAGE_TERMINAL_LOCATIONS,
        CAPABILITIES.MANAGE_CHAINS,
        CAPABILITIES.MANAGE_EMAILS,
        CAPABILITIES.MANAGE_SYSTEM_FEES,
        CAPABILITIES.MANAGE_BOOKING_PAYOUTS,
        CAPABILITIES.MANAGE_PAYOUT_REPORTS,
        CAPABILITIES.MANAGE_CUSTOM_REPORTS,
        CAPABILITIES.MANAGE_SALES_REPORTS,
        CAPABILITIES.MANAGE_REGIONS,
        CAPABILITIES.MANAGE_CANCEL_REASONS,
        CAPABILITIES.MANAGE_SOURCES,
        CAPABILITIES.MANAGE_SOURCE_GROUPS,
        CAPABILITIES.MANAGE_AUDIT_LOGS,
        CAPABILITIES.RE_SOURCE_BOOKING,
        CAPABILITIES.SEND_CUSTOM_MESSAGES,
        CAPABILITIES.MANAGE_HOTELS,
        CAPABILITIES.MANAGE_PRICE_ITEM_NAMES,
        CAPABILITIES.MANAGE_BATCHES
    ],
    [CAPABILITY_SET_NAMES.CUSTOM]: [CAPABILITIES.MANAGE_CLIENTS]
});

export const CAPABILITY_LABELS = Object.freeze({
    [CAPABILITIES.MANAGE_CLIENTS]: 'Manage clients',
    [CAPABILITIES.MANAGE_VENDORS]: 'Manage vendors',
    [CAPABILITIES.MANAGE_ACTIVITIES]: 'Manage activities',
    [CAPABILITIES.MANAGE_ACTIVITY_TAGS]: 'Manage activity tags',
    [CAPABILITIES.MANAGE_TERMINAL_LOCATIONS]: 'Manage terminal locations',
    [CAPABILITIES.MANAGE_CHAINS]: 'Manage chains',
    [CAPABILITIES.MANAGE_EMAILS]: 'Manage emails',
    [CAPABILITIES.MANAGE_SYSTEM_FEES]: 'Manage system fees',
    [CAPABILITIES.MANAGE_BOOKING_PAYOUTS]: 'Manage booking payouts',
    [CAPABILITIES.MANAGE_PAYOUT_REPORTS]: 'Manage payout reports',
    [CAPABILITIES.MANAGE_CUSTOM_REPORTS]: 'Manage custom reports',
    [CAPABILITIES.MANAGE_SALES_REPORTS]: 'Manage sales reports',
    [CAPABILITIES.MANAGE_REGIONS]: 'Manage regions',
    [CAPABILITIES.MANAGE_CANCEL_REASONS]: 'Manage cancel reasons',
    [CAPABILITIES.MANAGE_SOURCES]: 'Manage sources',
    [CAPABILITIES.MANAGE_SOURCE_GROUPS]: 'Manage source groups',
    [CAPABILITIES.MANAGE_AUDIT_LOGS]: 'Manage audit logs',
    [CAPABILITIES.MANAGE_HOTELS]: 'Manage hotels',
    [CAPABILITIES.MANAGE_PRICE_ITEM_NAMES]: 'Manage price item names',
    [CAPABILITIES.MANAGE_BATCHES]: 'Manage batches',
    [CAPABILITIES.RE_SOURCE_BOOKING]: 'Re-source booking',
    [CAPABILITIES.SEND_CUSTOM_MESSAGES]: 'Send custom Messages to customers [email, sms]',
    [CAPABILITIES.ALLOW_REFUND_OUTSIDE_CANCEL_WINDOW]: 'Allow refund outside cancel window',
    [CAPABILITIES.ALLOW_REFUND_WITHIN_CANCEL_WINDOW]: 'Allow refund within cancel window',
    [CAPABILITIES.ALLOW_MODIFY_OUTSIDE_CANCEL_WINDOW]: 'Allow modify outside cancel window',
    [CAPABILITIES.ALLOW_MODIFY_WITHIN_CANCEL_WINDOW]: 'Allow modify within cancel window',
    [CAPABILITIES.SHOW_DASHBOARD_ALERTS]: 'Show dashboard alerts modal on login'
});
